<template>
  <div>
    <validation-observer ref="ContractorFormValidator">
      <v-form>
        <v-card>
          <v-card-title>契約者{{ $route.params.id ? '編集' : '登録' }}</v-card-title>
          <v-card-text>
            <v-card-title>基本情報</v-card-title>

            <!-- 運用モード -->
            <v-row>
              <v-col cols="12" md="6">
                <v-radio-group v-model="contractor.jw_mode" label="運用モード" row dense hide-details="auto" class="pa-0 ma-0">
                  <v-radio label="通常モード" :value=false />
                  <v-radio label="JWモード" :value=true />
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- /運用モード -->

            <!-- 法人コード -->
            <v-row v-if="this.$route.params.id">
              <v-col cols="12" md="6">
                <div class="overline">
                  法人コード
                </div>
                <h4>{{ contractor.code }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /法人コード -->

            <!-- 法人名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|max:50" name="法人名" class="requiredMark">
                  <v-text-field v-model="contractor.name" :error-messages="errors" label="法人名"
                    hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人名</span>
                      <span class="ml-1">
                        ({{ contractor.name?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /法人名-->

            <!-- 法人名フリガナ -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|katakana_only|max:50" name="法人名フリガナ"
                  class="requiredMark">
                  <v-text-field v-model="contractor.name_kana" :error-messages="errors" label="法人名フリガナ"
                    hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人名フリガナ</span>
                      <span class="ml-1">
                        ({{ contractor.name_kana?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /法人名フリガナ-->

            <!-- 法人代表者名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|max:50" name="法人代表者名（姓）" class="requiredMark">
                  <v-text-field v-model="contractor.representative_last_name" :error-messages="errors"
                    label="法人代表者名（姓）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人代表者名（姓）</span>
                      <span class="ml-1">
                        ({{ contractor.representative_last_name?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|max:50" name="法人代表者名（名）" class="requiredMark">
                  <v-text-field v-model="contractor.representative_first_name" :error-messages="errors"
                    label="法人代表者名（名）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人代表者名（名）</span>
                      <span class="ml-1">
                        ({{ contractor.representative_first_name?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /法人代表者名 -->

            <!-- 法人代表者名フリガナ -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|katakana_only|max:50" name="法人代表者名フリガナ（姓）"
                  class="requiredMark">
                  <v-text-field v-model="contractor.representative_last_name_kana" :error-messages="errors"
                    label="法人代表者名フリガナ（姓）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人代表者名フリガナ（姓）</span>
                      <span class="ml-1">
                        ({{ contractor.representative_last_name_kana?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|katakana_only|max:50" name="法人代表者名フリガナ（名）"
                  class="requiredMark">
                  <v-text-field v-model="contractor.representative_first_name_kana" :error-messages="errors"
                    label="法人代表者名フリガナ（名）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>法人代表者名フリガナ（名）</span>
                      <span class="ml-1">
                        ({{ contractor.representative_first_name_kana?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /法人代表者名フリガナ -->

            <!-- 郵便番号 -->
            <v-row>
              <v-col cols="12" md="5">
                <validation-provider v-slot="{ errors }" rules="required|zip_code|max:8" name="郵便番号" class="requiredMark"
                  vid="contractor_zip_code">
                  <v-text-field v-model="contractor.zip_code" :error-messages="errors" label="郵便番号"
                    hide-details="auto" hint="ハイフンを含めて入力してください" persistent-hint persistent-placeholder
                    placeholder="例）111-1111" required
                  >
                    <template v-slot:label>
                      <span>郵便番号</span>
                      <span class="ml-1">
                        ({{ contractor.zip_code?.length || 0 }} / 8)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                    <template v-slot:append-outer>
                      <zip-code-search :zip-code="contractor.zip_code" @zipAddress="setZipAddress" />
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /郵便番号 -->
            <!-- 都道府県 -->
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider v-slot="{ errors }" name="都道府県">
                  <v-autocomplete v-model="contractor.prefecture_code" :error-messages="errors" :items="prefList"
                    item-text="text" item-value="value" label="都道府県" persistent-placeholder required hide-details="auto"/>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /都道府県 -->

            <!-- 市区町村 -->
            <v-row>
              <v-col>
                <validation-provider v-slot="{ errors }" rules="required|full_width|max:20" name="市区町村"
                  class="requiredMark" vid="contractor_address_1">
                  <v-text-field v-model="contractor.address_1" :error-messages="errors" label="市区町村"
                    hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>市区町村</span>
                      <span class="ml-1">
                        ({{ contractor.address_1?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /市区町村 -->

            <!-- 町域 -->
            <v-row>
              <v-col>
                <validation-provider v-slot="{ errors }" rules="full_width|max:40" name="町域">
                  <v-text-field v-model="contractor.address_2" :error-messages="errors" label="町域"
                    hide-details="auto" persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>町域</span>
                      <span class="ml-1">
                        ({{ contractor.address_2?.length || 0 }} / 40)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /町域 -->

            <!-- 詳細住所 -->
            <v-row>
              <v-col>
                <validation-provider v-slot="{ errors }" rules="max:50" name="詳細住所">
                  <v-text-field v-model="contractor.address_3" :error-messages="errors" label="詳細住所"
                    hide-details="auto" persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>詳細住所</span>
                      <span class="ml-1">
                        ({{ contractor.address_3?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /詳細住所 -->

            <v-card-title>申込担当者</v-card-title>

            <!-- 申込担当者名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|max:6" name="申込担当者名（姓）" class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_last_name" :error-messages="errors"
                    label="申込担当者名（姓）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>申込担当者名（姓）</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_last_name?.length || 0 }} / 6)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|max:6" name="申込担当者名（名）" class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_first_name" :error-messages="errors"
                    label="申込担当者名（名）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>申込担当者名（名）</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_first_name?.length || 0 }} / 6)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /申込担当者名 -->

            <!-- 申込担当者名フリガナ -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|katakana_only|max:10" name="申込担当者名フリガナ（姓）"
                  class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_last_name_kana" :error-messages="errors"
                    label="申込担当者名フリガナ（姓）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>申込担当者名フリガナ（姓）</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_last_name_kana?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|katakana_only|max:10" name="申込担当者名フリガナ（名）"
                  class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_first_name_kana" :error-messages="errors"
                    label="申込担当者名フリガナ（名）" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>申込担当者名フリガナ（名）</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_first_name_kana?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /申込担当者名フリガナ -->

            <!-- 申込担当者部署名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="max:20" name="申込担当者部署名">
                  <v-text-field v-model="contractor.supervisor_department_name" :error-messages="errors"
                    label="申込担当者部署名" hide-details="auto" persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>申込担当者部署名</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_department_name?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /申込担当者部署名-->

            <!-- 申込担当者電話番号・申込担当者FAX番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|numeric_hyphen_contract_only|max:15" name="申込担当者電話番号"
                  class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_phone_number" :error-messages="errors"
                    label="申込担当者電話番号" hide-details="auto" persistent-placeholder hint="電話番号を「-」ハイフン込みで入力します"
                    persistent-hint required
                  >
                    <template v-slot:label>
                      <span>申込担当者電話番号</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_phone_number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="numeric_hyphen_contract_only|max:15" name="申込担当者FAX番号">
                  <v-text-field v-model="contractor.supervisor_fax_number" :error-messages="errors"
                    label="申込担当者FAX番号" hide-details="auto" persistent-placeholder hint="FAX番号を「-」ハイフン込みで入力します"
                    persistent-hint
                  >
                    <template v-slot:label>
                      <span>申込担当者FAX番号</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_fax_number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /申込担当者電話番号・申込担当者FAX番号 -->

            <!-- 申込担当者メールアドレス -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider v-slot="{ errors }" rules="required|email|max:100" name="申込担当者メールアドレス"
                  class="requiredMark">
                  <v-text-field v-model="contractor.supervisor_email" :error-messages="errors"
                    label="申込担当者メールアドレス" hide-details="auto" persistent-placeholder required
                  >
                    <template v-slot:label>
                      <span>申込担当者メールアドレス</span>
                      <span class="ml-1">
                        ({{ contractor.supervisor_email?.length || 0 }} / 100)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /申込担当者メールアドレス -->

            <v-row>
              <!-- 契約単位 -->
              <v-col v-if="!contractor.registered_formally_contract && !registered_demo_contract" cols="12" md="4">
                <v-select v-model="contractor.contract_unit_type" :items="contract_unit_types"
                  :disabled="contractor.registered_formally_contract" label="契約単位" hide-details="auto"
                  persistent-placeholder />
              </v-col>
              <v-col v-else cols="12" md="4">
                <div class="overline">
                  契約単位
                </div>
                <h3 class="font-weight-medium black--text">
                  {{ contractor.contract_unit_type_name }}&nbsp;
                </h3>
                <v-divider />
              </v-col>
              <!-- /契約単位 -->
              <!-- 請求単位 -->
              <template
                v-if="contractor.contract_unit_type === 'paid_examination' || contractor.contract_unit_type === 'formally_contract'">
                <v-col v-if="contractor.registered_formally_contract && registered_invoice_type_year" cols="12" md="4">
                  <div class="overline">
                    請求単位
                  </div>
                  <h3 class="font-weight-medium black--text">
                    {{ contractor.invoice_type_name }}&nbsp;
                  </h3>
                  <v-divider />
                </v-col>
                <v-col v-else cols="12" md="4">
                  <validation-provider v-slot="{ errors }" class="requiredMark" rule="required" name="請求単位">
                    <v-select v-model="contractor.invoice_type" :error-messages="errors" :items="invoice_types"
                      label="請求単位" hide-details="auto" persistent-placeholder />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="4" v-if="contractor.invoice_type === 'month'">
                  <v-radio-group v-model="contractor.use_initial_cost" label="初期費用利用" row dense hide-details="auto" class="pa-0 ma-0">
                    <v-radio label="利用する" :value="true" />
                    <v-radio label="利用しない" :value="false" />
                  </v-radio-group>
                </v-col>

              </template>
              <!-- /請求単位 -->
            </v-row>

          <!-- /配車計画の利用 -->
            <!-- 申込日 -->
            <v-row>
              <v-col cols="12" md="4">
                <cs-date-picker
                  :date.sync="contractor.contract_date"
                  @dateChangedCallback="contractDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="申込日"
                      class="requiredMark"
                    >
                      <v-text-field
                        v-model="contractor.contract_date"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        clearable
                        hide-details="auto"
                        label="申込日"
                        persistent-hint
                        persistent-placeholder
                        readonly
                        required
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
            <!-- /申込日 -->

            <!-- 備考 -->
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider v-slot="{ errors }" name="備考" rules="max:5120">
                  <v-textarea v-model="contractor.remarks" :error-messages="errors" hide-details="auto"
                    label="備考" persistent-placeholder rows="3"
                  >
                    <template v-slot:label>
                      <span>備考</span>
                      <span class="ml-1">
                        ({{ contractor.remarks?.length || 0 }} / 5120)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /内容 -->

            <v-row v-if="(contractor.payment_type === 'payment_contractor' && contractor.paid_id === null) ||
              (contractor.payment_type === 'payment_tenant' && !contractor.exists_paid_connected_tenant)">
              <!-- 支払種別 -->
              <v-col cols="12" md="4">
                <v-select v-model="contractor.payment_type" :items="payment_types" label="支払種別" hide-details="auto"
                  persistent-placeholder />
              </v-col>
              <!-- /支払種別 -->
              <!-- 支払方法種別 -->
              <v-col v-if="contractor.payment_type === 'payment_contractor'" cols="12" md="4">
                <validation-provider v-slot="{ errors }" name="支払方法種別" rules>
                  <v-select v-model="contractor.payment_method_type" :items="payment_method_types"
                    :error-messages="errors" label="支払方法種別" hide-details="auto" persistent-placeholder />
                </validation-provider>
              </v-col>
              <!-- /支払方法種別 -->
            </v-row>
            <v-row v-else>
              <!-- 支払種別 -->
              <v-col cols="12" md="4">
                <div class="overline">
                  支払種別
                </div>
                <h3 class="font-weight-medium black--text">
                  {{ contractor.payment_type_name }}&nbsp;
                </h3>
                <v-divider />
              </v-col>
              <!-- /支払種別 -->
              <!-- 支払方法種別 -->
              <v-col v-if="contractor.payment_type === 'payment_contractor'" cols="12" md="4">
                <div class="overline">
                  支払方法種別
                </div>
                <h3 class="font-weight-medium black--text">
                  {{ contractor.payment_method_type_name }}&nbsp;
                </h3>
                <v-divider />
              </v-col>
              <!-- 支払方法種別 -->
            </v-row>
            <v-row v-if="contractor.paid_id !== null">
              <!-- Paid ID -->
              <v-col cols="12" md="4">
                <div class="overline" style="text-transform: none">
                  Paid ID
                </div>
                <h3 class="font-weight-medium black--text">
                  {{ contractor.paid_id }}&nbsp;
                </h3>
                <v-divider />
              </v-col>
              <!-- /Paid ID -->
              <!-- Paid 連携日時 -->
              <v-col cols="12" md="4">
                <div class="overline" style="text-transform: none">
                  Paid連携日時
                </div>
                <h3 class="font-weight-medium black--text">
                  {{ contractor.paid_connect_at }}&nbsp;
                </h3>
                <v-divider />
              </v-col>
              <!-- /Paid 連携日時 -->
              <!-- Paid 連携利用 -->
              <v-col cols="12" md="4">
                <v-radio-group v-model="contractor.use_paid" label="Paid連携利用" row dense hide-details="auto" class="pa-0 ma-0">
                  <v-radio label="利用する" :value="true" />
                  <v-radio label="利用しない" :value="false" />
                </v-radio-group>
              </v-col>
              <!-- /Paid 連携利用 -->
            </v-row>
            <!-- テナント -->
            <v-row>
              <v-col class="text-right">
                <v-btn color="info" @click="appendTenantButtonClickEvent">
                  <v-icon>mdi-plus</v-icon>&nbsp;テナントを追加する
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-tabs v-model="tenant_tabs" background-color="blue-grey lighten-4">
                  <template v-for="(tenant, i) in tenants">
                    <v-tab :key="i" style="text-transform: none">
                      {{ tenant.name ? tenant.name : '新規テナント' }}
                    </v-tab>
                  </template>
                  <template v-for="(tenant, i) in tenants">
                    <v-tab-item :key="'tab-' + i" :eager="true">
                      <v-row class="py-2">
                        <v-col>
                          <v-btn color="primary" @click="copyContractorToTenantButtonClickEvent(tenant)">
                            契約情報をテナントにコピーする
                          </v-btn>
                        </v-col>
                      </v-row>
                      <tenant-form
                        :tenant="tenant"
                        :payment-type="contractor.payment_type"
                        :contract-unit-type="contractor.contract_unit_type"
                        :invoice-free-terms="invoice_free_terms"
                        :ec-contract-invoice-free-terms="ec_contract_invoice_free_terms"
                        :ip-restrictions-invoice-free-terms="ip_restrictions_invoice_free_terms"
                        :api-invoice-free-terms="api_invoice_free_terms"
                        :freee-invoice-free-terms="freee_invoice_free_terms"
                        :jwnet-transfer-invoice-free-terms="jwnet_transfer_invoice_free_terms"
                        :proxy-entry-invoice-free-terms="proxy_entry_invoice_free_terms"
                        :payment-method-types="payment_method_types"
                        :price-plans="price_plans"
                        :ec-contract-price-plans="ec_contract_price_plans"
                        :ip-restrictions-price-plans="ip_restrictions_price_plans"
                        :api-price-plans="api_price_plans"
                        :freee-price-plans="freee_price_plans"
                        :jwnet-transfer-price-plans="jwnet_transfer_price_plans"
                        :proxy-entry-price-plans="proxy_entry_price_plans"
                        :tab-number="i" />
                      <v-row>
                        <v-col class="text-left">
                          <v-btn color="error" small :disabled="activeTenantCounter <= 1"
                            @click="removeSubscriberNumberButtonClickEvent(tenant)">
                            テナントを削除
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </template>
                </v-tabs>
              </v-col>
            </v-row>
            <!-- /加入者番号 -->
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="registerButtonClickEvent">
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
        <confirm ref="confirm" />
      </v-form>
    </validation-observer>
    <v-spacer class="mb-12" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Confirm from '../../../components/Confirm'
import TenantForm from "./_TenantForm";
import PrefectureList from '../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../components/ZipCodeSearch'
import _ from 'lodash'
import { name } from 'store/storages/cookieStorage';

export default {
  name: 'ContractorForm',
  components: {
    Confirm,
    ZipCodeSearch,
    TenantForm
  },
  mixins: [PrefectureList],
  data() {
    return {
      tenant_tabs: null,
      contract_unit_types: [],
      invoice_types: [],
      invoice_free_terms: [],
      ec_contract_invoice_free_terms: [],
      ip_restrictions_invoice_free_terms: [],
      api_invoice_free_terms: [],
      freee_invoice_free_terms: [],
      jwnet_transfer_invoice_free_terms: [],
      proxy_entry_invoice_free_terms: [],
      payment_types: [],
      payment_method_types: [],
      price_plans: [],
      ec_contract_price_plans: [],
      ip_restrictions_price_plans: [],
      api_price_plans: [],
      freee_price_plans: [],
      jwnet_transfer_price_plans: [],
      proxy_entry_price_plans: [],
      contractor: {},
      tenants: [],
      disposal_subscribers: [],
      registered_invoice_type_year: false,
      registered_demo_contract: false,
    }
  },
  computed: {
    activeTenantCounter: function () {
      let counter = 0
      for (const tenant of this.contractor.tenants_attributes) {
        if (!tenant._destroy) {
          counter = counter + 1
        }
      }
      return counter
    },
  },
  watch: {
    // 請求単位のセット
    'contractor.contract_unit_type': function (newVal) {
      if (this.registered_invoice_type_year) {
        return
      }
      // 契約種別が「Paid審査」「正式契約」の場合は初期値
      if (newVal === 'paid_examination' || newVal === 'formally_contract') {
        this.contractor.invoice_type = 'month'
      } else {
        // 「トライアル」「デモ」の場合はnull
        this.contractor.invoice_type = null
      }
    },
  },
  created() {
    this.tenants = []
    if (this.$route.params.id) {
      this.editAdminContractor({ id: this.$route.params.id }).then((content) => {
        this.contractor = content
        this.contract_unit_types = content.contract_unit_types
        this.invoice_types = content.invoice_types
        this.invoice_free_terms = content.invoice_free_terms
        this.ec_contract_invoice_free_terms = content.ec_contract_invoice_free_terms
        this.ip_restrictions_invoice_free_terms = content.ip_restrictions_invoice_free_terms
        this.api_invoice_free_terms = content.api_invoice_free_terms
        this.freee_invoice_free_terms = content.freee_invoice_free_terms
        this.jwnet_transfer_invoice_free_terms = content.jwnet_transfer_invoice_free_terms
        this.proxy_entry_invoice_free_terms = content.proxy_entry_invoice_free_terms
        this.payment_types = content.payment_types
        this.payment_method_types = content.payment_method_types
        this.price_plans = content.price_plans
        this.ec_contract_price_plans = content.ec_contract_price_plans
        this.ip_restrictions_price_plans = content.ip_restrictions_price_plans
        this.api_price_plans = content.api_price_plans
        this.freee_price_plans = content.freee_price_plans
        this.jwnet_transfer_price_plans = content.jwnet_transfer_price_plans
        this.proxy_entry_price_plans = content.proxy_entry_price_plans
        this.use_paid = content.use_paid
        // 通常の代入を行うとメモリの参照先が一緒になってしまい、加入者番号追加ボタンを押下すると2つ追加されてしまうため
        // DeepCopyで別メモリを参照するようにする
        this.tenants = _.cloneDeep(this.contractor.tenants_attributes)
        this.registered_invoice_type_year = (content.invoice_type === 'year')
        this.registered_demo_contract = (content.contract_unit_type === 'demo_contract')
      })
    } else {
      this.newAdminContractor().then((content) => {
        this.contractor = content
        this.contract_unit_types = content.contract_unit_types
        this.invoice_types = content.invoice_types
        this.invoice_free_terms = content.invoice_free_terms
        this.ec_contract_invoice_free_terms = content.ec_contract_invoice_free_terms
        this.ip_restrictions_invoice_free_terms = content.ip_restrictions_invoice_free_terms
        this.api_invoice_free_terms = content.api_invoice_free_terms
        this.freee_invoice_free_terms = content.freee_invoice_free_terms
        this.jwnet_transfer_invoice_free_terms = content.jwnet_transfer_invoice_free_terms
        this.proxy_entry_invoice_free_terms = content.proxy_entry_invoice_free_terms
        this.payment_types = content.payment_types
        this.payment_method_types = content.payment_method_types
        this.price_plans = content.price_plans
        this.ec_contract_price_plans = content.ec_contract_price_plans
        this.ip_restrictions_price_plans = content.ip_restrictions_price_plans
        this.api_price_plans = content.api_price_plans
        this.freee_price_plans = content.freee_price_plans
        this.jwnet_transfer_price_plans = content.jwnet_transfer_price_plans
        this.proxy_entry_price_plans = content.proxy_entry_price_plans
        this.appendTenantButtonClickEvent()
      })
    }

  },
  methods: {
    ...mapActions('AdminContractor', {
      newAdminContractor: 'new',
      editAdminContractor: 'edit',
      createAdminContractor: 'create',
      updateAdminContractor: 'update'
    }),
    /**
     * 申込日変更　コールバック
     */
    contractDateChangedCallback (value) {
      this.contractor.contract_date = value;
    },
    /**
     * テナント追加ボタン クリックイベント
     */
    appendTenantButtonClickEvent() {
      let tenant = {
        id: null,
        name: null,
        name_kana: null,
        subscriber_number: null,
        confirmation_number: null,
        edi_identify_key: null,
        zip_code: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        supervisor_last_name: null,
        supervisor_first_name: null,
        supervisor_last_name_kana: null,
        supervisor_first_name_kana: null,
        supervisor_department_name: null,
        supervisor_phone_number: null,
        supervisor_fax_number: null,
        supervisor_mobile_number: null,
        supervisor_email: null,
        paid_id: null,
        paid_connect_at: null,
        use_paid: false,
        formally_contract_date: null,
        invoice_start_date: null,
        invoice_free_term: 'none_term',
        payment_method_type: 'bank_transfer',
        price_plan: 'standard_plan',
        saas_monthly_price: 50000,
        saas_price_rev_date: null,
        saas_monthly_rev_price: null,
        registered_others_invoice: false,
        use_allocate: true,
        mode: 'transport',
        use_billing: false,
        ec_contract_start_date: null,
        ec_contract_end_date: null,
        use_ip_restrictions: false,
        allowed_ip_addresses: null,
        ec_contract_invoice_start_date: null,
        ec_contract_invoice_free_term: 'none_term_ec',
        ec_contract_price_plan: 'ec_contract_plan',
        ec_contract_monthly_price: 15000,
        ec_contract_price_rev_date: null,
        ec_contract_monthly_rev_price: null,
        ip_restrictions_formally_contract_date: null,
        ip_restrictions_invoice_start_date: null,
        ip_restrictions_invoice_free_term: 'none_term_ip',
        ip_restrictions_price_plan: 'ip_restrictions_plan',
        ip_restrictions_monthly_price: 10000,
        ip_restrictions_service_stop_date: null,
        ip_restrictions_price_rev_date: null,
        ip_restrictions_monthly_rev_price: null,
        use_api: false,
        api_start_date: null,
        api_end_date: null,
        api_invoice_free_term: 'none_term_api',
        api_price_plan: 'api_plan',
        api_monthly_price: 30000,
        api_price_rev_date: null,
        api_monthly_rev_price: null,
        use_freee_claim: false,
        freee_start_date: null,
        freee_end_date: null,
        freee_invoice_free_term: 'none_term_freee',
        freee_price_plan: 'freee_plan',
        freee_monthly_price: 30000,
        freee_price_rev_date: null,
        freee_monthly_rev_price: null,
        use_jwnet_transfer: false,
        jwnet_transfer_start_date: null,
        jwnet_transfer_end_date: null,
        jwnet_transfer_invoice_free_term: 'none_term_jwnet_transfer',
        jwnet_transfer_price_plan: 'jwnet_transfer_plan',
        jwnet_transfer_monthly_price: 10000,
        jwnet_transfer_price_rev_date: null,
        jwnet_transfer_monthly_rev_price: null,
        use_proxy_entry: false,
        proxy_entry_start_date: null,
        proxy_entry_end_date: null,
        proxy_entry_invoice_free_term: 'none_term_proxy_entry',
        proxy_entry_price_plan: 'proxy_entry_plan',
        proxy_entry_monthly_price: 10000,
        proxy_entry_price_rev_date: null,
        proxy_entry_monthly_rev_price: null,
        use_recycling: false,
        disposal_subscribers_attributes: [
          {
            id: null,
            key: new Date().getTime(),
            subscriber_number: null,
            confirmation_number: null,
            edi_usage_key: null,
            _destroy: false,
          }
        ],
        invoice_others_attributes: [
          {
            id: null,
            key: new Date().getTime(),
            others_price: null,
            others_invoice_date: null,
            others_title: null,
            _destroy: false,
            enabled: true,
          }
        ],
        proxy_entry_subscribers_attributes: [
          {
            id: null,
            key: new Date().getTime(),
            name: null,
            subscriber_number: null,
            confirmation_number: null,
            _destroy: false,
          }
        ],
        key: new Date().getTime(),
        _destroy: false,
      }
      this.contractor.tenants_attributes.push(tenant)
      this.tenants.push(tenant)
      this.tenant_tabs = (this.tenants.length - 1)
    },
    /**
     * テナント削除ボタン クリックイベント
     * @param item
     */
    removeSubscriberNumberButtonClickEvent(item) {

      // オリジナルデータから削除対象のデータを抽出し削除フラグをOnに変更
      for (const tenant of this.contractor.tenants_attributes) {
        if (tenant.key === item.key) {
          tenant._destroy = true
          break
        }
      }

      // オリジナルデータを走査し、削除されていないデータのみ抽出し、表示配列に詰め替え
      this.tenants = []
      for (const tenant of this.contractor.tenants_attributes) {
        if (!tenant._destroy) {
          this.tenants.push(tenant)
        }
      }
      // タブの選択位置を先頭に戻す
      this.tenant_tabs = 0
    },
    /**
     * 契約情報をテナント情報にコピーするボタンクリックイベント
     */
    copyContractorToTenantButtonClickEvent(tenant) {

      tenant.name = this.contractor.name
      tenant.name_kana = this.contractor.name_kana
      tenant.zip_code = this.contractor.zip_code
      tenant.prefecture_code = this.contractor.prefecture_code
      tenant.address_1 = this.contractor.address_1
      tenant.address_2 = this.contractor.address_2
      tenant.address_3 = this.contractor.address_3

      tenant.supervisor_last_name = this.contractor.supervisor_last_name
      tenant.supervisor_first_name = this.contractor.supervisor_first_name
      tenant.supervisor_last_name_kana = this.contractor.supervisor_last_name_kana
      tenant.supervisor_first_name_kana = this.contractor.supervisor_first_name_kana
      tenant.supervisor_department_name = this.contractor.supervisor_department_name
      tenant.supervisor_phone_number = this.contractor.supervisor_phone_number
      tenant.supervisor_fax_number = this.contractor.supervisor_fax_number
      tenant.supervisor_mobile_number = this.contractor.supervisor_mobile_number
      tenant.supervisor_email = this.contractor.supervisor_email
    },
    /**
     * 保存ボタン クリックイベント
     */
    registerButtonClickEvent() {
      let $self = this
      this.$refs.ContractorFormValidator.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      // 表示用の内容をオリジナルにコピー
      for (const tenant of this.contractor.tenants_attributes) {
        let newContent = this.tenants.find((o) => {
          return o.key === tenant.key;
        });
        if (newContent) {
          Object.assign(tenant, newContent)
        }
      }
      // 登録に必要ないパラメータを削除
      let params = _.cloneDeep(this.contractor)
      delete params.code
      delete params.prefectures
      delete params.payment_types
      delete params.contract_unit_types
      delete params.invoice_types
      delete params.invoice_free_terms
      delete params.ec_contract_invoice_free_terms
      delete params.ip_restrictions_invoice_free_terms
      delete params.api_invoice_free_terms
      delete params.freee_invoice_free_terms
      delete params.jwnet_transfer_invoice_free_terms
      delete params.proxy_entry_invoice_free_terms
      delete params.payment_method_types
      delete params.price_plans
      delete params.ec_contract_price_plans
      delete params.ip_restrictions_price_plans
      delete params.api_price_plans
      delete params.freee_price_plans
      delete params.jwnet_transfer_price_plans
      delete params.proxy_entry_price_plans
      delete params.payment_type_name
      delete params.payment_method_type_name
      delete params.contract_unit_type_name
      delete params.invoice_type_name
      delete params.registered_formally_contract
      delete params.exists_paid_connected_tenant
      for (const tenant of params.tenants_attributes) {
        delete tenant.price_plan_name
        delete tenant.ec_contract_price_plan_name
        delete tenant.ip_restrictions_price_plan_name
        delete tenant.invoice_free_term_name
        delete tenant.ec_contract_invoice_free_term_name      // 電子契約請求無料期間名
        delete tenant.ip_restrictions_invoice_free_term_name  // IPアドレス制限請求無料期間名
        delete tenant.exists_invoice
        delete tenant.exists_others_invoice
        delete tenant.exists_ec_contract_invoice
        delete tenant.exists_ip_restrictions_invoice
        delete tenant.payment_method_type_name
        delete tenant.service_stop
        // 収運モードの場合は処分加入者情報を全て削除対象として送る
        if (tenant.mode === 'transport') {
          tenant.disposal_subscribers_attributes.forEach((disposal) => {
            disposal._destroy = true
          })
        }
        // 他社区間代行起票を利用しない場合は他社区間代行起票加入者情報は送らない
        if (!tenant.use_proxy_entry) {
          delete tenant.proxy_entry_subscribers_attributes
        }
        // その他請求適用日は画面上年月指定なので01を追加
        let delkey = 0
        for (const other of tenant.invoice_others_attributes){
          // 全項目が未設定の場合は送らない。
          if (other.others_price == null && other.others_invoice_date == null && other.others_title == null){
            delete tenant.invoice_others_attributes[delkey]
          }
          other.others_invoice_date = other.others_invoice_date + '-01'
          delkey += 1
        }
      }

      if (this.contractor.id) {
        const result = this.contractor.tenants_attributes.some((object) => {
          return object._destroy === true;
        })
        if (result) {
          let modalOption = { title: '更新', message: 'テナント削除が含まれる更新です。よろしいですか？', options: { titleColor: 'red' } }
          this.$refs.confirm.open(modalOption).then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              this.updateAdminContractor({ id: this.contractor.id, params: params }).then(() => {
                this.$router.push({ name: 'AdminContractors' })
              })
            }
          })
        } else {
          this.updateAdminContractor({ id: this.contractor.id, params: params }).then(() => {
            this.$router.push({ name: 'AdminContractors' })
          })
        }

      } else {
        this.createAdminContractor({ params: params }).then(() => {
          this.$router.push({ name: 'AdminContractors', params: { resetPagination: true } })
        })
      }
    },
    /**
     * 取得した住所の反映
     * @param content
     */
    setZipAddress(content) {
      this.contractor.prefecture_code = `${content.pref_code}`
      this.contractor.address_1 = `${content.locality}`
      this.contractor.address_2 = `${content.street}`
    },
  }
}
</script>

<style scoped></style>
